export class Unresolved {
  public key: string;

  constructor(key: string) {
    this.key = key;
  }
}
